import {rcAjax} from '../util';
import {
    GET_BUSSINESS_CARD,
    SUBMIT_CARD_EVALUATION,
    GET_PZ_CARD,
    CHECK_CARD_EVALUATION
} from './ActionTypes';
export function businessCardinfo(dispatch, params) {
    const url = '/haoma/business/card?st=2';
    // const url2 = '/api/v1/businessCard';
    // const url = url1;
    return rcAjax('POST', url, {}, params, data => {
        dispatch({type: GET_BUSSINESS_CARD, data: data.data});
    });

}
export function submitEvaluation(dispatch, params) {
    return rcAjax('POST', '/api/v1/assessment/commit', {}, params, data => {
        dispatch({type: SUBMIT_CARD_EVALUATION, data: data.data});
    });
}

export function submitTypeEvaluation(dispatch, urlParams, params) {
    return rcAjax('POST', '/api/v1/assessment/commit', urlParams, params, data => {
        dispatch({type: SUBMIT_CARD_EVALUATION, data: data.data});
    });
}

export function getEvaluationStatus(dispatch, params) {
    return rcAjax('GET', '/api/v1/assessment/check?' + params, {}, {}, data => {
        dispatch({type: CHECK_CARD_EVALUATION, data: data.data});
    });
}

export function pzCardinfo(dispatch, params) {
    return rcAjax('POST', '/api/v1/pinzhuanCard', {}, params, data => {
        dispatch({type: GET_PZ_CARD, data: data.data});
    });
}